import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {rootMainPath} from '../../routes/paths';
import IconButtonMUI from '../../shared/IconButtonMUI';
import {ReactComponent as GoogleIcon} from '../../assets/icons/google.svg';
// import {ReactComponent as FaceBookIcon} from '../../assets/icons/facebook.svg';
// import {ReactComponent as AppleIcon} from '../../assets/icons/apple.svg';
import {useDispatch} from 'react-redux';
import {postSignInSocial} from '../../redux/actions/auth/authActions';

const Social = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    localStorage.getItem('token') && history.push(rootMainPath);
  }, []);

  const onAuthSocial = async (provider) => {
    await dispatch(postSignInSocial(provider)).then((res) => {
      if (!res.payload) {
        return;
      }
      window.location.href = res.payload.data.url;
    });
  };

  return (
    <div className='auth-box__social'>
      <IconButtonMUI onClick={() => onAuthSocial('google')}>
        <GoogleIcon />
      </IconButtonMUI>
      {/*<IconButtonMUI onClick={() => onAuthSocial('facebook')}>*/}
      {/*  <FaceBookIcon />*/}
      {/*</IconButtonMUI>*/}
    </div>
  );
};

export default Social;
